<mat-tab-group [selectedIndex]='index'  (selectedTabChange)="tabChanged($event)">
  <mat-tab label="Exposants">
    <app-liste-exhibitors ></app-liste-exhibitors>
  </mat-tab>
  <mat-tab label="Délégué">
    <app-list-delagate></app-list-delagate>
  </mat-tab>
  <mat-tab label="Speakers">
    <app-liste-speakers></app-liste-speakers>
  </mat-tab>
  <mat-tab label="Sponsors">
    <app-liste-sponsors></app-liste-sponsors>
  </mat-tab>
  <mat-tab label="Archivés">
    <app-liste-archivee [index]="index"></app-liste-archivee>
  </mat-tab>
  <mat-tab label="Notification E/S">
    <app-notfications [index]="index" ></app-notfications>
  </mat-tab>
</mat-tab-group>